import { useNavigate } from "react-router-dom";
import { Lock, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

/* Shown instead of the Client Workspace while the Connect rollout switch is off (server-enforced; this page is only the notice). */
export default function ClientUnavailable() {
  const { user, memberships, logout } = useAuth();
  const navigate = useNavigate();
  const other = memberships.find((m) => m.org_type !== "CLIENT");
  const signOut = async () => { await logout(); navigate("/login", { replace: true }); };
  return (
    <div data-testid="client-workspace-unavailable" className="flex min-h-screen items-center justify-center bg-jigsaw-bg px-4">
      <div className="w-full max-w-md rounded-2xl border border-jigsaw-border bg-white p-8 shadow-[0_1px_3px_rgba(16,24,47,0.05)]">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#FFF3E8] text-[#DF7916]"><Lock className="h-6 w-6" strokeWidth={1.75} /></span>
        <h1 className="mt-5 text-[22px] font-semibold leading-tight tracking-[-0.01em] text-jigsaw-navy">Client workspace is not currently available</h1>
        <p className="mt-2 text-sm text-jigsaw-muted">You are signed in{user?.email ? ` as ${user.email}` : ""}, but Jigsaw has not yet opened the client workspace. Nothing is wrong with your account - please contact your Jigsaw coordinator if you need help with a placement in the meantime.</p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          {other && <Button data-testid="client-unavailable-other-workspace" variant="outline" onClick={() => navigate(other.org_type === "INTERNAL" ? "/control-centre" : "/supplier")}>Open {other.org_type === "INTERNAL" ? "Control Centre" : "Supplier Workspace"}</Button>}
          <Button data-testid="client-unavailable-logout" onClick={signOut}><LogOut className="mr-1.5 h-4 w-4" /> Sign out</Button>
        </div>
      </div>
    </div>
  );
}
